import { LottoSmallDto } from '@desio/api';
import DashboardCard, { DashboardCardProps } from 'components/dashboard-card';
import Text from 'components/text';
import { TipoProfiloSede, userInfoSelector } from 'pages/admin/_redux/selectors';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import { useHistory, useLocation } from 'react-router-dom';
import Select, { SingleValue } from 'react-select';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getElencoDatiDashboard, getElencoLotti, setCampagna, setDataFine, setDataInizio } from './_redux/actions';
import { dataFormSelector, elencoDatiDashboardSelector, elencoLottiSelector } from './_redux/selectors';
import { LottoOption } from './_redux/types';

// tslint:disable:no-var-requires
//const DayPickerInput = require("react-day-picker/DayPickerInput").default;
const moment = require("moment");
require("moment-duration-format");

const HomeDashboard: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const tipoDashboard = pathname.startsWith('/admin/cruscotto-campagne') ? 1 : undefined;
  const { dataInizio, dataFine } = useAppSelector(dataFormSelector)
  const datiDashboard = useAppSelector(elencoDatiDashboardSelector);
  const elencoLotti = useAppSelector(elencoLottiSelector);
  const userInfo = useAppSelector(userInfoSelector);

  const toRef = useRef<DayPickerInput>();

  useEffect(() => {
    dispatch(getElencoDatiDashboard(tipoDashboard));
  }, [dispatch, tipoDashboard]);

  useEffect(() => {
    if (tipoDashboard == 1) {
      dispatch(getElencoLotti());
    }
  }, [tipoDashboard]);

  /* calendar */
  function showFromMonth() {
    if (!dataInizio) {
      return;
    }
    if (dataFine && moment(dataFine).diff(moment(dataInizio), 'months') < 2) {
      toRef.current?.getDayPicker().showMonth(dataInizio);
    }
  }

  function handleFromChange(day: Date) {
    dispatch(setDataInizio(day))
  }

  function handleCampagnaChange(option: SingleValue<LottoSmallDto>) {
    dispatch(setCampagna(option?.idLotto));
  }

  function handleToChange(to: Date) {
    dispatch(setDataFine(to));
    showFromMonth();
  }

  const goToRicerca = useCallback((statoCertificazione?: number) => {
    history.push({
      pathname: `/admin/ricerca`,
      state: {
        dataInizio: dataInizio,
        dataFine: dataFine,
        statoCertificazione: statoCertificazione
      }
    })
  }, [dispatch, history, dataInizio, dataFine]);

  const [dashData, setDashData] = useState<DashboardCardProps[]>([]);

  useEffect(() => {
    if (datiDashboard) {
      console.log('update', datiDashboard)
      setDashData([
        {
          title: String(datiDashboard.processiInseriti?.numeroProcessiTotale || 0),
          subtitle: "Certificazioni create",
          details: datiDashboard.processiInseriti,
          showDetails: !tipoDashboard,
          infoText: "Numero di certificazioni create nel periodo selezionato. Non sono considerate le certificazioni nello stato \"Invalidata\"",
          callback: () => goToRicerca(),
          callbackLink: 'Vai al dettaglio >'
        },
        {
          title: String(datiDashboard.processiConclusi?.numeroProcessiTotale || 0) + ' (' + String(datiDashboard.processiConclusi?.percProcessiTotale || 0) + '%)',
          subtitle: "Certificazioni concluse",
          details: datiDashboard.processiConclusi,
          showDetails: !tipoDashboard,
          infoText: "Numero di certificazioni concluse dai clienti",
          callback: () => goToRicerca(5),
          callbackLink: 'Vai al dettaglio >'
        },
        {
          title: String(datiDashboard.processiAvviati?.numeroProcessiTotale || 0) + ' (' + String(datiDashboard.processiAvviati?.percProcessiTotale || 0) + '%)',
          subtitle: "Certificazioni inviate al cliente e non ancora finalizzate",
          details: datiDashboard.processiAvviati,
          showDetails: !tipoDashboard,
          infoText: "Numero di certificazioni che sono state inviate al cliente e ancora in attesa di conclusione",
          callback: () => goToRicerca(4),
          callbackLink: 'Vai al dettaglio >'
        },
        {
          title: String(datiDashboard.processiPreviewInviata?.numeroProcessiTotale || 0) + ' (' + String(datiDashboard.processiPreviewInviata?.percProcessiTotale || 0) + '%)',
          subtitle: "Email informative di certificazione inviate al cliente ",
          details: datiDashboard.processiPreviewInviata,
          showDetails: !tipoDashboard,
          infoText: "Numero di email informative inviate al cliente. Le email informative sono quelle che avvisano il cliente che nei prossimi giorni riceverà l'email di certificazione dei propri contatti",
          callback: () => goToRicerca(6),
          callbackLink: 'Vai al dettaglio >'
        },
        {
          title: String(datiDashboard.processiInseritiNonAvviati?.numeroProcessiTotale || 0) + ' (' + String(datiDashboard.processiInseritiNonAvviati?.percProcessiTotale || 0) + '%)',
          subtitle: "Certificazioni inserite ma non inviate al cliente",
          details: datiDashboard.processiInseritiNonAvviati,
          showDetails: !tipoDashboard,
          infoText: "Numero di certificazioni che sono state inserite ma non avviate, in questo caso il cliente non ha ricevuto l'email di certificazione",
          callback: () => goToRicerca(1),
          callbackLink: 'Vai al dettaglio >'
        },
        {
          title: String(datiDashboard.processiScaduti?.numeroProcessiTotale || 0) + ' (' + String(datiDashboard.processiScaduti?.percProcessiTotale || 0) + '%)',
          subtitle: "Certificazioni scadute",
          details: datiDashboard.processiScaduti,
          showDetails: !tipoDashboard,
          infoText: "Numero di certificazioni scaduta. Le certificazioni hanno una durata di 7gg, 3 gg prima della scadenza è inviata un'email di promemoria al cliente",
          callback: () => goToRicerca(3),
          callbackLink: 'Vai al dettaglio >'
        },
        {
          title: (datiDashboard.percConversionRate || '0') + '%',
          subtitle: "Conversion rate",
          infoText: "Percentuale di certificazione su gruppo di utenti a cui è stata inviata la richiesta. E' il rapporto tra le certificazioni concluse e quelle create."
        },
        {
          title: moment.duration(datiDashboard.mediaTemporaleDiAttesa || 0, "minutes").format("hh [ore] mm [minuti] ss [secondi]", {
            usePlural: false
          }),
          subtitle: "Media temporale di attesa",
          infoText: "Tempo intercorso tra invio richiesta e certificazione conclusa"
        }
      ]);
    }
  }, [datiDashboard, goToRicerca]);


  const filterOptions = (inputValue: string) => {
    return (elencoLotti ?? []).filter((i) =>
      i.nomeLotto?.toLowerCase().includes(inputValue.toLowerCase())
    )
      .map((x, _) => {

        const option: LottoOption = {
          value: x.idLotto,
          label: x.nomeLotto ?? ""
        };

        return option;
      });
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: LottoOption[]) => void
  ) => {
    callback(filterOptions(inputValue));
  };

  const modifiers = { start: dataInizio, end: dataFine };
  return (
    <div>
      <div className="mb-5 ">
        {userInfo && userInfo?.tipoProfilo !== TipoProfiloSede &&
          <Row className="mb-3">
            <Col>
              <Text title={userInfo && userInfo?.tipoProfilo !== TipoProfiloSede ? "Dati filtrati per filiale prevalente: " + userInfo.codiceFiliale : ""} type='sottotitolo' />
            </Col>
          </Row>}

        <Row className="InputFromTo" style={{ alignItems: 'flex-end' }}>
          {tipoDashboard &&
            <Col lg={5}>
              <Text title="Campagna"></Text>
              <Select
                isClearable
                isSearchable
                onChange={handleCampagnaChange}
                key={JSON.stringify(elencoLotti)}
                placeholder="Seleziona"
                noOptionsMessage={() => "Nessuna campagna trovata"}
                getOptionLabel={item => item.nomeLotto ?? ""}
                getOptionValue={item => String(item.idLotto ?? 0)}
                options={elencoLotti} />
            </Col>
          }
          <Col lg={3}>
            <Text title="Data Inizio"></Text>
            <DayPickerInput
              value={dataInizio}
              placeholder="From"
              format="LL"
              formatDate={MomentLocaleUtils.formatDate}
              parseDate={MomentLocaleUtils.parseDate}
              inputProps={{ className: 'form-control' }}
              dayPickerProps={{
                locale: 'it',
                localeUtils: MomentLocaleUtils,
                selectedDays: [dataInizio, { from: dataInizio, to: dataFine }],
                disabledDays: { after: dataFine },
                toMonth: dataFine,
                modifiers,
                numberOfMonths: 2,
                onDayClick: () => toRef.current?.getInput().focus(),
              }}
              onDayChange={handleFromChange}
            />
          </Col>
          <Col lg={3}>
            <span className="InputFromTo-to">
              <Text title="Data Fine"></Text>
              <DayPickerInput
                ref={(ref: any) => toRef.current = ref}
                value={dataFine}
                placeholder="To"
                format="LL"
                hideOnDayClick={false}
                formatDate={MomentLocaleUtils.formatDate}
                parseDate={MomentLocaleUtils.parseDate}
                inputProps={{ className: 'form-control' }}
                dayPickerProps={{
                  locale: 'it',
                  localeUtils: MomentLocaleUtils,
                  selectedDays: [dataInizio, { from: dataInizio, to: dataFine }],
                  disabledDays: { before: dataInizio },
                  modifiers,
                  month: dataInizio,
                  fromMonth: dataInizio,
                  numberOfMonths: 2,
                }}
                onDayChange={handleToChange}
              />
            </span>
          </Col>

          <Col md={1}>
            <Button onClick={() => dispatch(getElencoDatiDashboard())} className="button">Cerca</Button>
          </Col>
        </Row>
      </div>
      <Row>
        {dashData.map((data: DashboardCardProps, index: number) =>
          <Col md={index < 6 ? 4 : 6} className="mt-4" key={index}>
            <DashboardCard title={data.title} details={data.details} showDetails={data.showDetails} subtitle={data.subtitle} infoText={data.infoText} callback={data.callback} callbackLink={data.callbackLink} />
          </Col>
        )}
      </Row>
    </div >
  )
}

export default HomeDashboard;
